import { FC, PropsWithChildren } from "react";
import IconCamera from "@/assets/imgs/svg/icon-camera.svg";
import { theme } from "tailwind.config";

type Props = {
  imageSrc: string;
  size?: number;
};

const ImageInputView: FC<PropsWithChildren<Props>> = ({
  children,
  imageSrc,
  size = 160,
}) => {
  return (
    <div
      className={[
        "group relative bg-cover bg-center bg-repeat aspect-square rounded-full bg-gray-100 overflow-hidden cursor-pointer",
        "[&>input]:absolute [&>input]:inset-0 [&>input]:opacity-0 [&>input]:cursor-pointer",
      ].join(" ")}
      style={{
        width: size,
        height: size,
        backgroundImage: `url(${imageSrc})`,
      }}
    >
      {children}

      <div className="absolute inset-0 pointer-events-none bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition"></div>
      {!imageSrc && (
        <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <IconCamera width={32} height={32} fill={theme.colors.gray[950]} />
        </span>
      )}
    </div>
  );
};
export default ImageInputView;
